import React from 'react';
import PropTypes from 'prop-types';

const RoleIcon = ({ size = '32px', fill = '#000' }) => (
  <svg x="0px" y="0px" width={size} height={size} viewBox="0 0 128 128">
    <path fill={fill} d="M101.1,105.6C93.7,92.7,79.9,84,64,84h0c-15.9,0-29.7,8.7-37.1,21.6L27,109h74L101.1,105.6z" />
    <path fill="#444b54" d="M78.8,89.7c-0.3,0-0.7-0.1-1-0.2c-4.4-1.6-9-2.5-13.8-2.5c-1.7,0-3-1.3-3-3s1.3-3,3-3c5.5,0,10.8,1,15.9,2.8c1.6,0.6,2.3,2.3,1.8,3.9C81.2,88.9,80,89.7,78.8,89.7z" />
    <path fill="#444b54" d="M26.9,108.6c-0.5,0-1-0.1-1.5-0.4c-1.4-0.8-1.9-2.6-1.1-4.1C32.4,89.9,47.6,81,64,81c1.7,0,3,1.3,3,3s-1.3,3-3,3c-14.2,0-27.4,7.7-34.5,20.1C29,108,28,108.6,26.9,108.6z" />
    <path fill="#fff" d="M64 30A20 20 0 1 0 64 70A20 20 0 1 0 64 30Z" />
    <path fill="#444b54" d="M64,73c-12.7,0-23-10.3-23-23s10.3-23,23-23s23,10.3,23,23S76.7,73,64,73z M64,33c-9.4,0-17,7.6-17,17s7.6,17,17,17s17-7.6,17-17S73.4,33,64,33z" />
    <g>
      <path fill="#fff" d="M107.9,109h-14c-1.7,0-3-1.3-3-3s1.3-3,3-3h14c1.7,0,3,1.3,3,3S109.6,109,107.9,109z" />
    </g>
    <g>
      <path fill="#71c2ff" d="M119,94h-1.1c0-0.2,0.1-0.3,0.1-0.5V85c0-7.7-6.3-14-14-14s-14,6.3-14,14v9h-1c-2.8,0-5,2.2-5,5v7c0,11,9,20,20,20s20-9,20-20v-7C124,96.2,121.8,94,119,94z M96,94v-9c0-4.4,3.6-8,8-8s8,3.6,8,8v8.5c0,0.2,0,0.3,0.1,0.5H96z" />
      <path fill="#fff" d="M104,110.7c-1.7,0-3-1.3-3-3v-0.2c0-1.7,1.3-3,3-3s3,1.3,3,3v0.2C107,109.4,105.7,110.7,104,110.7z" />
    </g>
  </svg>
);


RoleIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

export default RoleIcon;
